import { Tooltip } from '@/components/primitives/Tooltip'

import { Row } from '../../Row'

import { useTexts } from '../useTexts'

interface Props {
  count: number
  onSelect: () => void
}

export function OrdersUnassigned(props: Props) {
  const { count, onSelect } = props
  const texts = useTexts()

  return (
    <Tooltip
      textAlign="left"
      placement="right"
      title={texts.unassigned}
      subtitle={texts.unassignedTooltip}
    >
      <Row
        onClick={onSelect}
        text={texts.unassigned}
        value={count}
        disabled={count === 0}
        testId="plan-summary-unassigned-orders"
      />
    </Tooltip>
  )
}
